// constants
import { PackagesActionTypes } from "./constants";

//Action
export interface PackagesActionType {
  type:
    | PackagesActionTypes.GET_LIST_PACKAGES_ERROR
    | PackagesActionTypes.GET_LIST_PACKAGES_SUCCESS
    | PackagesActionTypes.GET_LIST_PACKAGES
    | PackagesActionTypes.CREATE_PACKAGE
    | PackagesActionTypes.CREATE_PACKAGE_SUCCESS
    | PackagesActionTypes.CREATE_PACKAGE_ERROR
    | PackagesActionTypes.GET_PACKAGE
    | PackagesActionTypes.GET_PACKAGE_SUCCESS
    | PackagesActionTypes.GET_PACKAGE_ERROR
    | PackagesActionTypes.UPDATE_PACKAGE
    | PackagesActionTypes.UPDATE_PACKAGE_SUCCESS
    | PackagesActionTypes.UPDATE_PACKAGE_ERROR
    | PackagesActionTypes.DELETE_PACKAGE
    | PackagesActionTypes.DELETE_PACKAGE_SUCCESS
    | PackagesActionTypes.DELETE_PACKAGE_ERROR;
  payload: {} | string;
}

//Interfaces
interface PackagesData {
  items?: any[];
  total?: number;
  country?: string;
  keyword?: string;
  limit?: number;
  skip?: number;
  owner?: string;
}

interface PackageCreate {
  name: string;
  pack: { [countryCode: string]: number };
}

interface PackageUpdate {
  name: string;
  pack: { [countryCode: string]: number };
}

interface GetPackage {
  id: string;
}

interface DeletePackage {
  ids: string[];
}

//Package_List
export const packagesGetListSuccess = (
  actionType: string,
  data: PackagesData | {}
): PackagesActionType => ({
  type: PackagesActionTypes.GET_LIST_PACKAGES_SUCCESS,
  payload: { actionType, data },
});

export const packagesGetListError = (
  actionType: string,
  error: string
): PackagesActionType => ({
  type: PackagesActionTypes.GET_LIST_PACKAGES_ERROR,
  payload: { actionType, error },
});

export const getPackagesList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  owner: string = "",
  country: string = "ic"
): PackagesActionType => ({
  type: PackagesActionTypes.GET_LIST_PACKAGES,
  payload: { keyword, limit, skip, owner, country },
});

//Create Package
export const createPackageSuccess = (
  actionType: string,
  data: PackageCreate | {}
): PackagesActionType => ({
  type: PackagesActionTypes.CREATE_PACKAGE_SUCCESS,
  payload: { actionType, data },
});

export const createPackageError = (
  actionType: string,
  error: string
): PackagesActionType => ({
  type: PackagesActionTypes.CREATE_PACKAGE_ERROR,
  payload: { actionType, error },
});

export const createPackage = (
  name: string,
  pack: { [countryCode: string]: number }
): PackagesActionType => ({
  type: PackagesActionTypes.CREATE_PACKAGE,
  payload: {
    name,
    pack,
  },
});

//Update Package
export const updatePackageSuccess = (
  actionType: string,
  data: PackageUpdate | {}
): PackagesActionType => ({
  type: PackagesActionTypes.UPDATE_PACKAGE_SUCCESS,
  payload: { actionType, data },
});

export const updatePackageError = (
  actionType: string,
  error: string
): PackagesActionType => ({
  type: PackagesActionTypes.UPDATE_PACKAGE_ERROR,
  payload: { actionType, error },
});

export const updatePackage = (
  id: string,
  data: PackageUpdate
): PackagesActionType => ({
  type: PackagesActionTypes.UPDATE_PACKAGE,
  payload: { id, ...data },
});

//GET Package

export const getPackageSuccess = (
  actionType: string,
  data: GetPackage | {}
): PackagesActionType => ({
  type: PackagesActionTypes.GET_PACKAGE_SUCCESS,
  payload: { actionType, data },
});

export const getPackageError = (
  actionType: string,
  error: string
): PackagesActionType => ({
  type: PackagesActionTypes.GET_PACKAGE_ERROR,
  payload: { actionType, error },
});

export const getPackage = (id: string): PackagesActionType => ({
  type: PackagesActionTypes.GET_PACKAGE,
  payload: { id },
});

//DELETE Package

export const deletePackageSuccess = (
  actionType: string,
  data: DeletePackage | {}
): PackagesActionType => ({
  type: PackagesActionTypes.DELETE_PACKAGE_SUCCESS,
  payload: { actionType, data },
});

export const deletePackageError = (
  actionType: string,
  error: string
): PackagesActionType => ({
  type: PackagesActionTypes.DELETE_PACKAGE_ERROR,
  payload: { actionType, error },
});

export const deletePackage = (ids: string[]): PackagesActionType => ({
  type: PackagesActionTypes.DELETE_PACKAGE,
  payload: { ids },
});
